import {
  TableBody as MuiTableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const NoDataRow = ({ text = "No data" }) => {
  const { t } = useTranslation();
  return (
    <MuiTableBody>
      <TableRow>
        <TableCell align="center" colSpan={20}>
          {t(text)}
        </TableCell>
      </TableRow>
    </MuiTableBody>
  );
};

NoDataRow.propTypes = {
  text: PropTypes.string,
  noOfCols: PropTypes.number,
};

export default NoDataRow;
